/* stylelint-disable no-descending-specificity, a11y/media-prefers-reduced-motion */

import { keyframes } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const ListWrapper = styled.div({
  marginTop: token('space.250'),
  paddingBottom: '50px',
  minWidth: '650px',
  width: '100%',
  minHeight: '400px',
});

export const Loading = styled.div`
  width: 100%;
  animation: fadein 0.25s ease-out;
  text-align: center !important;
  padding: 100px 0 100px !important;
`;

export const EmptyQuery = styled.div({
  margin: '60px 0',
  textAlign: 'center',
});

export const Pagination = styled.div({
  display: 'flex',
  justifyContent: 'center',
  margin: `${token('space.100')} 0`,
});

export const RowWrapper = styled.tr({
  td: {
    padding: token('space.100'),
  },
  "[headers='branch'], [headers='commit']": {
    verticalAlign: 'middle',
  },
  "[headers='started'], [headers='duration'], [headers='status']": {
    color: token('color.text'),
    width: '200px',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    '> a': {
      textDecoration: 'none',
    },
  },
  "[headers='started']": {
    whiteSpace: 'nowrap',
  },
  "[headers='status']": {
    '.PipelineRowStatus': {
      position: 'static',
      marginRight: token('space.100'),
      "[class$='status']": {
        flexDirection: 'row',
      },
    },
  },
  '&:hover, &:focus': {
    backgroundColor: token('elevation.surface.raised.hovered'),
    boxShadow: token('elevation.shadow.raised'),
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: token('border.radius', '3px'),
  },
});

export const AuthorCol = styled.td`
  padding-right: 0 !important;
  width: 1%;
  vertical-align: middle !important;
`;

export const CommitMessage = styled.div({
  padding: '1px 0 0',
  maxWidth: '420px',
  minWidth: '300px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  '& > *': {
    display: 'inline',
  },
});

export const PipelineLink = styled.div({
  a: {
    color: token('color.text'),
    fontWeight: token('font.weight.medium'),
  },
});

export const PipelineInfoText = styled.span({
  color: token('color.text.subtlest'),
  font: token('font.body.UNSAFE_small'),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '160px',
  display: 'inline-block',
  whiteSpace: 'nowrap',
  marginRight: '3px',
});

export const ScheduledIcon = styled.div({
  color: token('color.icon'),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: token('color.icon.subtle'),
  borderRadius: '100%',
  width: '34px',
  height: '34px',
});

export const PipelineInfoLink = styled.a({
  color: token('color.text.subtlest'),
  font: token('font.body.UNSAFE_small'),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '200px',
  display: 'inline-block',
  whiteSpace: 'nowrap',
  marginRight: '6px',
  '&:focus': {
    color: token('color.text.subtlest'),
  },
  '&:first-of-type': {
    marginRight: '3px',
  },
  '&:last-child': {
    margin: 0,
  },
  svg: {
    position: 'relative',
    top: token('space.025'),
  },
});

const spin = keyframes({
  to: {
    transform: 'translateY(-5rem)',
  },
});

export const InProgress = styled.span({
  display: 'inline-block',
  overflow: 'hidden',
  height: '1.25rem',
  marginTop: '-0.625rem',
  font: token('font.body'),
  '&::after': {
    display: 'inline-table',
    whiteSpace: 'pre',
    textAlign: 'left',
    content: "'\\A.\\A..\\A...'",
    animation: `${spin} 2s steps(4) infinite`,
  },
});
